module.exports = __webpack_public_path__ + "static/amy-c1854f12e28df91423936b6d015e2e47.jpg";